<template lang="pug">
  div
    Card.a8-page-description-card
        h2 {{$t('tasks.pageTitleText')}}
    RcmTable(
      :esIndex="esIndex"
      :esIndexFields="esIndexFields"
      :exportFields="exportFields"
      :sort="sort"
      ref="rcmTable"
      v-bind:searchView="$options.name"
      primarySearchKey="actionName"
      primarySearchKeyI18="操作名稱"
      :rowClassInfo="rowClassInfo")
</template>
<script>
import Vue from "vue";
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("TagList", TagList);

import RcmTable from "@/components/RcmTable_v2";
import JsonPoptip from "@/components/JsonPoptip";
import TagList from "@/components/TagList";

export default {
    name: "Tasks",
    components: { RcmTable, TagList, JsonPoptip },
    data() {
        return {
            esIndex: "rcm-tasksqueue",
            sort: [{ submitTime: { order: "desc" } }],
            rowClassInfo: {
                key: "state",
                values: [],
                valuesNot: ["完成"],
                className: "table-disabled-row",
                defaultClassName: "",
            },
            exportFields: [
                "submitTime",
                "username",
                "actionName",
                "objId",
                "decodeObjId",
                "request_source",
                "runCounter",
                "taskNo",
                "trainNo",
                "state",
                "errorMsg",
                "finishedTime",
            ],
            esIndexFields: [
                "submitTime",
                "username",
                "actionName",
                "objId",
                "decodeObjId",
                "request_source",
                "diffData",
                "originData",
                "requestData",
                "scope",
                "scopeResult",
                "runCounter",
                "taskNo",
                "trainNo",
                "state",
                "errorMsg",
                "finishedTime",
            ],
            generalFields: [],
        };
    },
    computed: {},
    methods: {},
    mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/view/monitor/Tasks.vue